import indexationStore from "./store/indexationStore";
import IndexationTableWidget from "./components/widget/IndexationTableWidget";
import IndexationEditWidget from "./components/widget/IndexationEditWidget";

export default {
  // The install method will be called with the Vue constructor as
  // the first argument, along with possible options
  install(Vue, options) {
    if (!options || !options.store) {
      throw new Error('Please initialise plugin with a Vuex store.');
    }
    options.store.registerModule('indexationPlugin', indexationStore);

    Vue.component('IndexationTableWidget', IndexationTableWidget);
    Vue.component('IndexationEditWidget', IndexationEditWidget);
  },
};
